// extracted by mini-css-extract-plugin
export default {"content":"admission-category-delete_content__jk5hR","buttons":"admission-category-delete_buttons__9cyeJ","button":"admission-category-delete_button__srcKC"};